import React, {Component} from 'react';
import ClientPageBackButton from "./../ClientPageBackButton";
import ScrollToComponent from "./../ScrollToComponent";

import BossNaslovna from '../../images/boss-heading.jpg';

let BossNaslovnaImg = {
    backgroundImage: `url(${BossNaslovna})`,
    backgroundPosition: 'center center',
    backgroundSize: 'contain',
    height: '100vh'
};

export default class BossPage extends Component {
    constructor(props) {
        super(props);
    }

    scrollNodes = [
        '#section1',
        '#section2',
        '#section3',
        '#section4',
        '#section5',
        '#section6',
        '#section7',
        '#section8'
    ];

    render() {
        return (
            <main className="smart-page">
                <ClientPageBackButton parentThis={this} currentSlideGroup={2} path="/en" />
                <ScrollToComponent scrollNodes={this.scrollNodes}/>

                <div className="main-image-page main-boss" style={BossNaslovnaImg}></div>
                <div id="section1" className="section-1">
                    <img src="img/boss-first-1.png" alt="boss smart agency"/>
                    <div id="section2" className="right-bottom-text background-black">
                        <p className="first-text">LOVE AT FIRST SIGHT</p>
                        <p className="content-text">The taste and preparation of food are the most important elements for enjoying it. But for us from the world of marketing – the "packaging" is just as important.</p>
                        <p className="content-text">Cafe pizzeria Boss from Subotica, which dictates trends in the restaurant and cuisine industries in the whole country, entrusts the Smart designing team with creating the visual identity of its menus.</p>
                    </div>
                </div>
                <section id="section3" className="section-3 boss-section top-image">
                    <img className="image-top" src="img/boss-section-3.png" alt="boss smart agency"/>
                    <div id="section4" className="left-bottom-text background-olive">
                        <p className="first-text">TRADITION AND EXPERIENCE</p>
                        <p className="content-text">Stara Pizzeria, the restaurant with long and rich tradition located in downtown Subotica, which became famous as a scene for excellent rock concerts as well, cooperates constantly with the Smart creative team.</p>
                    </div>
                </section>
                <section id="section5" className="boss-section chinese">
                    <img src="/img/boss-section-4.png" alt="boss smart agency"/>
                    <div id="section6" className="right-bottom-text background-gray-dark">
                        <p className="first-text">FOOD PACKAGING</p>
                        <p className="content-text">A challenging and inspirational task – to design an attractive, practical and unique packaging for the food to go that will only add to the restaurant's image. Smart likes complex creative tasks!</p>
                    </div>
                </section>
                <section  id="section7" className="boss-section packing">
                    <img src="/img/boss-section-7.png" alt="boss smart agency"/>
                    <div id="section8" className="left-bottom-text background-gray">
                        <p className="first-text">HOW TO PACK PIZZA TO GO</p>
                        <p className="content-text">An interesting bag, modernly designed, with a wide base that could fit the whole pizza box. Each task has a smart solution.</p>
                    </div>
                </section>

            </main>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/English/BossEnglishPage.js